import React, { useEffect, useMemo } from 'react';
import { Box, Card, Typography, Avatar } from '@mui/material';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import { Icon } from '@iconify/react';
import { Skeleton } from '@mui/material';
import NoDataFound from '../../../../../components/NodataIndication/NoDataFound';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { getSogoCards } from '../../../../../redux/features/poinTrackerSlice';

export default function CardsHeader({ fromDate, toDate, selectedTeam }) {
  const dispatch = useDispatch();
  const { loading, responseData } = useSelector((state) => state.pointTracker.sogoCards);

  const dispatchParams = useMemo(() => {
    return {
      fromDate,
      toDate,
      wingId: selectedTeam?.id === -1 ? null : selectedTeam?.id,
    };
  }, [fromDate, toDate, selectedTeam?.id]);

  useEffect(() => {
    if (fromDate && toDate) {
      dispatch(getSogoCards(dispatchParams));
    }
  }, [dispatch, dispatchParams]);

  useEffect(() => {
    console.log('API Triggered:', dispatchParams);
  }, [dispatchParams]);
  const cardsData = responseData?.data || [];

  // const data = [
  //   { short:avatar, title: wingName, name: userName, value: sales },

  // ];

  const data = useMemo(() => {
    return cardsData.map((item) => ({
      short: item.avatar,
      title: item.wingName,
      name: item.userName,
      value: item.sales,
    }));
  }, [cardsData]);

  const noDatafound = !loading && data.length === 0;

  const formatCurrency = (value) => `₹${Number(value || 0).toLocaleString('en-IN')}`;

  return (
    <Box
      sx={{
        display: 'flex',
        gap: 2,
        flexWrap: 'wrap',
        mt: 1,
      }}
    >
      {loading ? (
        <Box
          sx={{
            display: 'flex',
            gap: 2,
            flexWrap: 'wrap',
          }}
        >
          {[...Array(5)].map((_, index) => (
            <Card
              key={index}
              sx={{
                width: '100%',
                borderRadius: 3,
                minWidth: 220,
                flex: '1 1 180px',
                height: 170,
                p: 2,
                border: `1px solid #e0e0e0`,
              }}
            >
              {/* Top Row Skeleton */}
              <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
                <Box sx={{ display: 'flex', gap: 1 }}>
                  <Skeleton variant="circular" width={32} height={32} />
                  <Skeleton variant="text" width={40} height={20} />
                </Box>
                <Skeleton variant="circular" width={24} height={24} />
              </Box>

              {/* Name Skeleton */}
              <Skeleton variant="text" width="80%" height={20} sx={{ mb: 1 }} />

              {/* Label */}
              <Skeleton variant="text" width="40%" height={15} />

              {/* Value */}
              <Skeleton variant="text" width="60%" height={30} />
            </Card>
          ))}
        </Box>
      ) : noDatafound ? (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '30vh',
          }}
        >
          <NoDataFound />
        </Box>
      ) : (
        <Box
          sx={{
            display: 'flex',
            gap: 2,
            flexWrap: 'wrap',
          }}
        >
          {data.map((item, index) => (
            <Card
              key={index}
              sx={{
                width: '100%',
                p: 2,
                borderRadius: 3,
                bgcolor: '#eef3fb',
                boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
                minWidth: 220, //  important for scroll
                flexShrink: 0, //  prevents shrinking
                flex: '1 1 180px', // equal width
                height: 170, // same height
                padding: 2,

                boxShadow: 3,
                border: `1px solid ${'#9ebdf0'}`,
              }}
            >
              {/* Top Row */}
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  mb: 1,
                }}
              >
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <Avatar
                    sx={{
                      width: 32,
                      height: 32,
                      bgcolor: '#3b5bfd',
                      fontSize: 14,
                      fontWeight: 'bold',
                    }}
                  >
                    {item.short}
                  </Avatar>
                  <Typography fontWeight="bold">{item.title}</Typography>
                </Box>

                <Icon icon="ic:round-adjust" width="24" height="24" style={{ color: '#1448f5' }} />
              </Box>

              {/* Name */}
              <Typography
                variant="body2"
                sx={{
                  borderBottom: '1px solid #cfd8e3',
                  pb: 0.5,
                  mb: 1,
                  fontWeight: 500,
                }}
              >
                👤 {item.name}
              </Typography>

              {/* Sales */}
              <Typography variant="caption" color="text.secondary">
                Sales
              </Typography>

              <Typography variant="h6" fontWeight="bold" sx={{ color: '#2563eb' }}>
                {formatCurrency(item.value)}
              </Typography>
            </Card>
          ))}
        </Box>
      )}
    </Box>
  );
}
